import React from 'react';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';

const JHSIC = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary flex items-center justify-center">
                <div className="max-w-4xl mx-auto px-4 text-center">
                    <h1 className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-accent-primary to-purple-500 mb-8 tracking-tighter">
                        JHSIC 2026
                    </h1>
                    <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
                        Jharkhand School Innovation Challenge 2026 is upcoming!
                        Explore the details of previous years and get ready for the next wave of innovation.
                    </p>
                    <a
                        href="https://nvctijhsic.in/index.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-accent-primary hover:bg-accent-hover text-white font-black py-5 px-10 rounded-2xl shadow-2xl shadow-accent-primary/30 transform transition hover:scale-105 active:scale-95"
                    >
                        View JHSIC Portal & Details
                    </a>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default JHSIC;
